/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/21/20
 * Time: 6:18 PM
 */   
export const gender = [
    {key: 0, text: 'Male', value: 'MALE'},
    {key: 1, text: 'Female', value: 'FEMALE'},
];
export const grades = [
    {key: 0, text: '2020 A/L - Theory', value: '2020 A/L - Theory'},
    {key: 1, text: '2020 A/L - Revision', value: '2020 A/L - Revision'},
    {key: 2, text: '2021 A/L - Theory', value: '2021 A/L - Theory'},
    {key: 3, text: '2022 A/L - Theory', value: '2022 A/L - Theory'},
    {key: 4, text: '2020 O/L', value: '2020 O/L'},
    {key: 5, text: '2021 O/L', value: '2021 O/L'},
];
export const provinces = [
    {key: 0, text: 'Western Province', value: 'Western Province'},
    {key: 1, text: 'Southern Province', value: 'Southern Province'},
    {key: 2, text: 'North Central Province', value: 'North Central Province'},
    {key: 3, text: 'North Western Province', value: 'North Western Province'},
    {key: 4, text: 'Northern Province', value: 'Northern Province'},
    {key: 5, text: 'Sabaragamuwa Province', value: 'Sabaragamuwa Province'},
    {key: 6, text: 'Eastern Province', value: 'Eastern Province'},
    {key: 7, text: 'Uva Province', value: 'Uva Province'},
    {key: 8, text: 'Central Province', value: 'Central Province'},
];


export const months = [
    {key: 0, value: "JANUARY", text: "Jan"},
    {key: 1, value: "FEBRUARY", text: "Feb"},
    {key: 2, value: "MARCH", text: "Mar"},
    {key: 3, value: "APRIL", text: "Apr"},
    {key: 4, value: "MAY", text: "May"},
    {key: 5, value: "JUNE", text: "Jun"},
    {key: 6, value: "JULY", text: "Jul"},
    {key: 7, value: "AUGUST", text: "Aug"},
    {key: 8, value: "SEPTEMBER", text: "Sep"},
    {key: 9, value: "OCTOBER", text: "Oct"},
    {key: 10, value: "NOVEMBER", text: "Nov"},
    {key: 11, value: "DECEMBER", text: "Dec"}
];

export const districs = [
    {key: 'Ampara', text: 'Ampara', value: 'Ampara'},
    {key: 'Anuradhapura', text: 'Anuradhapura', value: 'Anuradhapura'},
    {key: 'Badulla', text: 'Badulla', value: 'Badulla'},
    {key: 'Batticaloa', text: 'Batticaloa', value: 'Batticaloa'},
    {key: 'Colombo', text: 'Colombo', value: 'Colombo'},
    {key: 'Galle', text: 'Galle', value: 'Galle'},
    {key: 'Gampaha', text: 'Gampaha', value: 'Gampaha'},
    {key: 'Hambantota', text: 'Hambantota', value: 'Hambantota'},
    {key: 'Jaffna', text: 'Jaffna', value: 'Jaffna'},
    {key: 'Kalutara', text: 'Kalutara', value: 'Kalutara'},
    {key: 'Kandy', text: 'Kandy', value: 'Kandy'},
    {key: 'Kegalle', text: 'Kegalle', value: 'Kegalle'},
    {key: 'Kilinochchi', text: 'Kilinochchi', value: 'Kilinochchi'},
    {key: 'Kurunegala', text: 'Kurunegala', value: 'Kurunegala'},
    {key: 'Mannar', text: 'Mannar', value: 'Mannar'},
    {key: 'Matale', text: 'Matale', value: 'Matale'},
    {key: 'Matara', text: 'Matara', value: 'Matara'},
    {key: 'Monaragala', text: 'Monaragala', value: 'Monaragala'},
    {key: 'Mullaitivu', text: 'Mullaitivu', value: 'Mullaitivu'},
    {key: 'NuwaraEliya', text: 'NuwaraEliya', value: 'NuwaraEliya'},
    {key: 'Polonnaruwa', text: 'Polonnaruwa', value: 'Polonnaruwa'},
    {key: 'Puttalam', text: 'Puttalam', value: 'Puttalam'},
    {key: 'Ratnapura', text: 'Ratnapura', value: 'Ratnapura'},
    {key: 'Trincomalee', text: 'Trincomalee', value: 'Trincomalee'},
    {key: 'Vavuniya', text: 'Vavuniya', value: 'Vavuniya'},
];
